import { render } from "./top.vue?vue&type=template&id=3fd16366"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__